var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect2, _path15, _path16, _rect3, _path17, _path18, _path19, _path20, _path21, _g, _path22, _g2, _path23, _g3, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _circle, _circle2, _circle3, _circle4, _g4, _path38, _rect4, _rect5, _path39, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthLayout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 555,
    height: 401,
    viewBox: "0 0 555 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 307,
    y: 194,
    width: 63,
    height: 115,
    rx: 6,
    fill: "#B3CFC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2714 335.395C29.8225 333.535 27.1775 333.535 26.7286 335.395L26.1472 337.803C25.9867 338.468 25.4679 338.987 24.8034 339.147L22.3947 339.729C20.5351 340.177 20.5351 342.823 22.3947 343.271L24.8034 343.853C25.4679 344.013 25.9867 344.532 26.1472 345.197L26.7286 347.605C27.1775 349.465 29.8225 349.465 30.2714 347.605L30.8528 345.197C31.0133 344.532 31.5321 344.013 32.1966 343.853L34.6053 343.271C36.4649 342.823 36.4649 340.177 34.6053 339.729L32.1966 339.147C31.5321 338.987 31.0133 338.468 30.8528 337.803L30.2714 335.395Z",
    fill: "#07EA97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.126 44.7666C291.587 42.4111 288.413 42.4111 287.874 44.7666L287.177 47.8176C286.984 48.6593 286.361 49.3165 285.564 49.5197L282.674 50.2562C280.442 50.8248 280.442 54.1752 282.674 54.7438L285.564 55.4803C286.361 55.6835 286.984 56.3407 287.177 57.1824L287.874 60.2334C288.413 62.5889 291.587 62.5889 292.126 60.2334L292.823 57.1824C293.016 56.3407 293.639 55.6835 294.436 55.4803L297.326 54.7438C299.558 54.1752 299.558 50.8248 297.326 50.2562L294.436 49.5197C293.639 49.3165 293.016 48.6593 292.823 47.8176L292.126 44.7666Z",
    fill: "#07EA97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.717 387.427C138.717 393.537 143.726 398.49 149.905 398.49C156.084 398.49 161.094 393.537 161.094 387.427C161.094 381.317 156.084 376.363 149.905 376.363C143.726 376.363 138.717 381.317 138.717 387.427Z",
    fill: "#1E2F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.166 310.053H140.329C139.43 310.053 138.702 309.3 138.702 308.369C138.702 307.438 139.43 306.685 140.329 306.685H165.166C166.066 306.685 166.793 307.438 166.793 308.369C166.793 309.3 166.066 310.053 165.166 310.053Z",
    fill: "#1D7051"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.496 383.999C146.661 383.999 145.986 383.259 145.986 382.344V317.72C145.986 316.363 145.441 315.099 144.484 314.236L138.412 308.779C137.765 308.203 137.671 307.155 138.206 306.456C138.731 305.747 139.688 305.644 140.336 306.23L146.408 311.687C148.069 313.177 149.017 315.377 149.017 317.73V382.354C149.017 383.269 148.341 384.009 147.506 384.009L147.496 383.999Z",
    fill: "#1D7051"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.336 394.225C179.278 391.848 178.088 389.168 175.677 388.239C173.267 387.31 170.549 388.484 169.606 390.861C168.664 393.237 169.855 395.917 172.265 396.846C174.676 397.775 177.393 396.602 178.336 394.225Z",
    fill: "#E5EFEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M182.491 381.461H222.146V345.78H182.491V381.461Z",
    fill: "#4F9078"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.017 381.461H194.337V327.089H149.017V381.461Z",
    fill: "#B3CFC4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M148.048 385H224.696C225.626 385 226.38 384.246 226.38 383.316C226.38 382.386 225.626 381.632 224.696 381.632H148.048C147.117 381.632 146.363 382.386 146.363 383.316C146.363 384.246 147.117 385 148.048 385Z",
    fill: "#1D7051"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.01 384.984H176.009V381.336H146.01V384.984Z",
    fill: "#1D7051"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.327 384.871C173.396 384.871 172.644 384.129 172.644 383.212V318.408C172.644 317.017 172.038 315.729 170.971 314.873L164.209 309.401C163.487 308.824 163.383 307.772 163.979 307.061C164.564 306.35 165.63 306.247 166.351 306.835L173.114 312.307C174.964 313.801 176.02 316.027 176.02 318.408V383.212C176.02 384.129 175.267 384.871 174.337 384.871H174.327Z",
    fill: "#1D7051"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M259.413 215L51 160.866L136.5 105H354L418 160.866L259.413 215Z",
    fill: "#81AF9E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M419 306H208V165.5L290.5 160.5L353.653 105L419 160.5V306Z",
    fill: "#D9E6E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M291 160H52V306H291V160Z",
    fill: "#D9E6E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 194,
    width: 72,
    height: 112,
    fill: "#81AF9E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154 194H84C72.4 194 72.0001 205.5 72 210H154V194Z",
    fill: "#4F9078"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.001 210V194C140.401 194 137.667 204.667 138.001 210H154.001Z",
    fill: "#E5EFEB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 194,
    width: 72,
    height: 112,
    fill: "#81AF9E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M249 194H179C167.4 194 167 205.5 167 210H249V194Z",
    fill: "#4F9078"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M249.001 210V194C235.401 194 232.667 204.667 233.001 210H249.001Z",
    fill: "#E5EFEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M432 29H324C324 29 334.704 0 351.188 0C367.672 0 372.828 20.0156 372.828 20.0156C372.828 20.0156 383.945 9.14188 393.081 9.14188C402.218 9.14188 410.159 23.5107 410.159 23.5107C410.159 23.5107 423.064 15.7857 432 29Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M505 87.9896H455C455 87.9896 466.171 72 474.971 72C483.771 72 486.372 82.6632 486.372 82.6632C486.372 82.6632 492.581 77.6891 498.34 78.5803C504.098 79.4715 504.989 88 504.989 88L505 87.9896Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M171 51.9894H73C73 51.9894 86.4255 21.9746 100.78 20.1033C115.134 18.232 122.005 42.4003 122.005 42.4003C122.005 42.4003 131.262 33.8579 138.544 33.8579C145.827 33.8579 151.442 45.1174 151.442 45.1174C151.442 45.1174 166.008 37.4102 171 52V51.9894Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5618_121606)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.257 132.573H429.999C436.937 132.573 441.582 137.444 441.582 144.688V161.41C441.582 168.632 436.937 173.502 429.999 173.502H412.257C405.319 173.502 400.653 168.632 400.653 161.41V144.688C400.653 137.444 405.319 132.573 412.257 132.573ZM419.951 159.157L429.672 149.436C430.368 148.74 430.368 147.615 429.672 146.898C428.976 146.203 427.83 146.203 427.134 146.898L418.683 155.35L415.101 151.769C414.406 151.073 413.259 151.073 412.564 151.769C411.868 152.465 411.868 153.59 412.564 154.307L417.434 159.157C417.782 159.505 418.232 159.668 418.683 159.668C419.153 159.668 419.603 159.505 419.951 159.157Z",
    fill: "white"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M412.65 151.768L419.001 157.695L429.163 147.11",
    stroke: "#07EA97",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5618_121606)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 171.074,
    cy: 100.77,
    r: 25.4043,
    fill: "white"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.938 99.1779C161.938 94.1947 166.262 90.167 171.493 90.167C176.738 90.167 181.062 94.1947 181.062 99.1779C181.062 101.689 180.114 104.02 178.553 105.996C176.831 108.176 174.709 110.075 172.32 111.565C171.773 111.91 171.279 111.936 170.679 111.565C168.277 110.075 166.154 108.176 164.447 105.996C162.885 104.02 161.938 101.689 161.938 99.1779ZM168.344 99.4585C168.344 101.128 169.758 102.441 171.493 102.441C173.228 102.441 174.656 101.128 174.656 99.4585C174.656 97.8021 173.228 96.4252 171.493 96.4252C169.758 96.4252 168.344 97.8021 168.344 99.4585Z",
    fill: "#07EA97"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5618_121606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.478 272.885L110.811 274.568L112.107 267.993L112.566 265.681L110.465 265.258C110.465 265.258 110.434 265.258 110.424 265.258L104.222 263.999L102.468 272.896L102.478 272.885Z",
    fill: "#EDB691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2246 284.414C102.407 288.636 106.038 293.28 109.333 297.45C110.088 298.42 110.996 299.586 112.036 300.236C112.25 300.381 112.454 300.505 112.658 300.618C113.515 301.103 114.229 301.3 115.076 301.681L117.401 302.641L132.987 307.626L134.017 308.308C134.629 308.638 135.364 308.586 135.935 308.184L136.965 307.441C138.046 306.512 139.719 306.192 141.137 306.192H141.708L139.27 304.902L136.475 304.943C132.752 302.972 128.081 300.546 123.776 298.348C121.695 297.274 119.696 296.253 117.942 295.355C116.718 294.684 116.116 294.581 115.749 293.91C115.463 293.486 115.178 293.053 114.872 292.63C111.914 288.305 108.721 283.702 105.732 279.512L99.2246 284.404V284.414Z",
    fill: "#EDB691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.974 400H137.373L137.312 399.412C137.139 397.864 136.159 396.501 134.711 395.675C134.109 395.325 133.426 395.066 132.701 394.932L123.368 393.178L116.126 394.406L115.341 398.235L114.984 400.01L114.974 400Z",
    fill: "#03603D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5791 400H93.4619V399.535C93.4619 397.873 92.4419 396.367 90.8404 395.531C90.463 395.334 90.055 395.18 89.6266 395.066L86.0668 394.127L81.0279 392.785L80.7423 397.44L80.5893 400.01L80.5791 400Z",
    fill: "#03603D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 390.907L80.5787 400L84.0569 397.832L86.403 396.387L86.0562 394.117L85.1586 388.131L79.2527 385.561L74.2954 389.803L73 390.907Z",
    fill: "#03603D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2512 389.503C87.933 391.815 92.0233 393.085 92.4619 392.373C92.4721 392.373 92.4721 392.352 92.4823 392.352C92.4925 392.331 92.5027 392.321 92.5027 392.29L106.079 361.193L110.628 350.768L111.24 349.365L111.404 347.858L112.556 337.072L112.577 336.897L114.974 314.366L96.9907 313.086L95.9605 345.216L96.6847 343.863L95.9095 346.764L95.9605 345.216L88.341 359.521C88.341 359.521 88.2696 359.655 88.1574 359.882L75.3563 383.899C74.989 384.663 78.5285 387.171 83.2512 389.503Z",
    fill: "#BBC0C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9092 346.764L96.6844 343.863L95.9602 345.215L95.9092 346.764Z",
    fill: "#BBC0C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9703 321.777C98.4493 321.715 99.9589 321.467 101.489 321.085C107.731 319.537 114.29 315.966 120.318 315.729C120.104 314.263 119.819 312.446 119.431 310.599C118.941 308.266 118.278 305.893 117.391 304.117C110.659 303.859 98.9185 304.138 98.9185 304.138C98.9185 304.138 97.7251 305.645 96.7051 308.101C95.328 311.414 94.2876 316.441 96.9703 321.777Z",
    fill: "#BBC0C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.954 266.606L105.865 267.765L103.585 253.491L111.47 252.201C113.494 251.87 115.41 253.261 115.739 255.319L116.702 261.351C117.101 263.847 115.421 266.203 112.954 266.606Z",
    fill: "#EDB691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.044 255.897C115.33 256.32 114.585 256.588 113.79 256.836C113.545 256.908 113.331 256.599 113.474 256.392C114.035 255.639 114.871 255.174 115.789 255.051C116.258 254.999 116.452 255.68 116.044 255.897Z",
    fill: "#1E2F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.579 254.142C106.773 256.402 107.222 258.632 108.568 259.117C109.914 259.602 111.659 258.178 112.464 255.917C113.27 253.657 112.821 251.428 111.475 250.942C110.129 250.457 108.384 251.882 107.579 254.142Z",
    fill: "#1E2F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4918 301.887C94.553 302.455 94.6958 302.961 94.961 303.394C96.1136 305.417 99.4694 306.232 106.661 306.79C113.413 307.316 119.043 306.728 119.502 304.953C119.513 304.911 119.523 304.87 119.523 304.818C119.523 304.787 119.523 304.756 119.523 304.726C119.502 303.652 119.39 299.039 118.87 293.641C118.37 288.418 117.483 282.453 115.953 278.242C113.658 271.966 104.345 268.891 101.05 274.062C94.4816 284.362 94.4918 301.361 94.4918 301.361H94.502C94.4714 301.526 94.4714 301.701 94.4918 301.877V301.887Z",
    fill: "#03603D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.513 304.963H119.543C119.543 304.963 119.543 304.891 119.543 304.736C119.543 304.767 119.543 304.798 119.543 304.829C119.543 304.871 119.533 304.912 119.523 304.963H119.513Z",
    fill: "#BBC0C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.652 273.277C101.652 273.277 107.466 274.206 111.087 274.774C112.791 275.032 114.005 275.218 113.923 275.187C113.841 275.166 111.669 270.501 111.669 270.501C111.669 270.501 110.853 269.902 108.905 269.283C107.589 268.86 105.732 268.437 103.274 268.179L101.652 273.277Z",
    fill: "#03603D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.081 261.811L101.897 262.523L103.825 263.266L106.334 263.659L109.058 261.687L109.098 261.532L110.751 255.03L108.231 251.387L102.774 252.264C102.081 252.863 101.754 253.812 101.52 255.278C101.418 255.887 101.326 256.589 101.244 257.383C101.02 259.417 100.377 261.068 100.153 261.615C100.132 261.677 100.102 261.728 100.081 261.79C100.081 261.811 100.071 261.811 100.071 261.811H100.081Z",
    fill: "#1E2F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.221 261.047C109.027 261.863 110.21 262.007 110.853 261.357C111.495 260.707 111.363 259.52 110.547 258.694C109.741 257.879 108.558 257.734 107.915 258.384C107.272 259.035 107.405 260.222 108.221 261.047Z",
    fill: "#EDB691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.802 260.604C108.802 260.604 108.731 260.593 108.71 260.562C108.496 260.346 108.353 260.067 108.323 259.778C108.292 259.479 108.374 259.221 108.557 259.035C108.935 258.653 109.608 258.725 110.067 259.19C110.118 259.241 110.118 259.334 110.067 259.386C110.016 259.437 109.924 259.437 109.873 259.386C109.526 259.035 109.016 258.962 108.751 259.231C108.629 259.355 108.567 259.54 108.598 259.747C108.618 259.964 108.731 260.191 108.904 260.366C108.955 260.418 108.955 260.511 108.904 260.562C108.873 260.593 108.843 260.604 108.812 260.604H108.802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.418 268.272C100.734 268.365 101.091 268.272 101.438 268.055C102.09 268.406 102.886 268.602 103.733 268.602C104.62 268.602 105.457 268.375 106.13 267.993C108.588 268.788 111.026 268.024 111.577 266.28C111.883 265.341 111.281 263.947 110.281 262.73C109.934 262.296 109.537 261.883 109.098 261.532C108.476 261.016 107.803 260.603 107.129 260.387C105.65 259.902 105.191 261.264 104.131 261.79C104.141 261.357 104.12 260.954 104.059 260.593C103.916 259.695 103.559 259.055 103.008 258.9C102.09 258.642 100.948 259.788 100.163 261.605C100.142 261.666 100.112 261.718 100.091 261.78V261.801C99.9382 262.172 99.7954 262.585 99.6832 263.008C98.9692 265.599 99.2956 267.952 100.428 268.272H100.418Z",
    fill: "#1E2F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.225 253.244L100.755 257.424V257.445L104.651 256.722L116.545 254.513L116.014 252.49C116.014 252.49 115.994 252.408 115.984 252.367C114.954 248.682 111.292 246.391 107.559 247.134L104.519 247.732L104.101 247.815C101.591 248.31 99.9084 250.684 100.225 253.244Z",
    fill: "#03603D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.755 257.455L100.806 257.899V257.951C101 258.725 105.784 258.168 111.496 256.733C117.208 255.298 121.686 253.502 121.502 252.739L121.4 252.295L120.196 252.357V252.398C118.36 252.377 114.821 252.955 110.822 253.957C106.518 255.04 102.907 256.33 101.479 257.228L100.755 257.476V257.455Z",
    fill: "#1E2F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.755 257.424V257.444V257.465C100.867 257.899 102.428 257.919 104.804 257.599C106.62 257.341 108.905 256.897 111.383 256.268C117.106 254.833 121.594 253.037 121.4 252.274C121.278 251.758 119.105 251.83 115.984 252.366C114.413 252.625 112.607 253.006 110.7 253.491C108.293 254.09 106.12 254.761 104.427 255.38C102.173 256.206 100.755 256.97 100.755 257.424Z",
    fill: "#03603D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.097 299.503C114.097 299.503 114.117 299.576 114.138 299.607C114.658 300.36 117.595 299.194 120.686 297.006C123.726 294.849 125.796 292.506 125.368 291.711C125.368 291.69 125.358 291.68 125.347 291.67C124.827 290.906 121.89 292.082 118.799 294.271C115.831 296.376 113.791 298.657 114.097 299.514V299.503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.076 291.071C115.443 292.825 116.82 294.57 118.146 296.262C118.819 295.695 119.686 295.044 120.747 294.374C122.246 293.434 123.562 292.867 124.552 292.547C123.736 291.36 122.899 290.132 122.063 288.903L114.107 290.844L114.086 291.071H114.076Z",
    fill: "#C7875C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.915 284.3C110.557 286.478 112.322 288.78 114.097 291.061C115.464 292.815 116.83 294.56 118.167 296.252C118.452 296.624 118.738 296.975 119.013 297.336C119.768 298.306 120.676 299.472 121.726 300.123C122.889 300.897 123.726 301.103 124.766 301.568L142.922 308.152L143.901 308.751C144.972 309.185 146.248 308.173 147.298 307.316C148.124 306.635 149.249 306.521 150.32 306.5L152.101 306.491L149.479 304.602L147.798 303.95L146.258 304.107L145.391 304.602C144.789 304.943 144.054 304.953 143.453 304.602C138.302 301.681 132.488 297.738 127.632 295.241C126.408 294.57 125.806 294.467 125.439 293.806C125.154 293.383 124.868 292.97 124.572 292.547C123.766 291.35 122.92 290.132 122.083 288.904C119.87 285.694 117.606 282.443 115.423 279.408L108.925 284.3H108.915Z",
    fill: "#EDB691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.708 257.527L117.36 259.488C117.595 259.767 117.483 260.201 117.146 260.335L115.555 260.933L115.708 257.527Z",
    fill: "#EDB691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.642 284.063L107.436 290.648L114.087 299.524H114.107C113.791 298.667 115.841 296.376 118.809 294.27C121.91 292.082 124.837 290.906 125.358 291.669C125.368 291.68 125.378 291.7 125.378 291.711L125.398 291.69L114.852 276.239L103.652 284.063H103.642Z",
    fill: "#03603D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.259 258.797C115.523 258.797 115.738 258.501 115.738 258.136C115.738 257.771 115.523 257.476 115.259 257.476C114.994 257.476 114.779 257.771 114.779 258.136C114.779 258.501 114.994 258.797 115.259 258.797Z",
    fill: "#261C17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.433 306.759C138.433 306.759 138.403 306.759 138.382 306.759L123.317 300.969C121.766 300.319 120.389 299.277 119.339 297.956L117.38 295.52C117.329 295.458 117.34 295.365 117.401 295.313C117.462 295.262 117.554 295.272 117.605 295.334L119.563 297.77C120.593 299.05 121.93 300.061 123.429 300.691L138.495 306.481C138.566 306.512 138.607 306.594 138.576 306.667C138.556 306.728 138.505 306.759 138.444 306.759H138.433Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.928 295.035C126.928 295.035 126.877 295.035 126.856 295.014C126.846 295.014 125.357 294.199 123.694 294.116C123.613 294.116 123.551 294.044 123.562 293.961C123.562 293.879 123.623 293.817 123.715 293.827C125.449 293.91 126.938 294.725 126.999 294.756C127.071 294.797 127.091 294.88 127.06 294.952C127.03 295.004 126.989 295.025 126.938 295.025L126.928 295.035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.974 400H137.373L137.312 399.412C137.139 397.864 136.159 396.501 134.711 395.676C134.017 396.089 133.385 396.863 133.191 398.225H115.341L114.984 400H114.974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 390.907L80.5787 400H93.4615V399.536C93.4615 397.874 92.4414 396.367 90.84 395.531C90.1056 395.82 89.2488 396.46 88.8204 397.833H81.0785L80.7317 397.43L74.2954 389.803L73 390.917V390.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.048 335.648C107.619 339.549 108.843 343.595 109.679 347.724L110.189 350.263C110.189 350.098 110.169 349.922 110.169 349.757L110.301 350.82L110.189 350.263C110.21 350.706 110.23 351.14 110.25 351.584C110.954 366.116 111.627 396.955 111.627 396.955C111.995 397.709 116.105 397.43 120.981 396.305C125.938 395.149 129.814 393.57 129.682 392.734C129.682 392.734 129.682 392.724 129.682 392.713C129.151 389.266 127.03 365.239 125.938 352.069C125.857 351.078 125.755 350.077 125.632 349.086C125.469 347.744 125.285 346.413 125.071 345.092C123.888 337.836 124.041 332.737 119.135 310.062C118.186 305.645 101.57 313.365 101.57 313.365C100.091 319.475 102.743 327.401 106.058 335.648H106.048Z",
    fill: "#BBC0C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.096 299.658C114.096 299.658 114.014 299.637 113.984 299.596L108.2 291.927C107.374 290.833 106.201 290.028 104.885 289.667L103.824 289.378C103.753 289.357 103.702 289.275 103.722 289.203C103.743 289.13 103.824 289.079 103.896 289.099L104.957 289.388C106.323 289.77 107.558 290.606 108.425 291.752L114.208 299.42C114.259 299.482 114.249 299.575 114.177 299.627C114.147 299.647 114.116 299.658 114.096 299.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.412 277.21C115.412 277.21 115.31 277.179 115.29 277.137C115.29 277.137 114.81 276.291 113.831 275.29C113.821 275.29 113.811 275.269 113.8 275.269C112.852 274.32 111.781 273.546 110.598 272.988C109.924 272.658 109.19 272.39 108.415 272.204C108.333 272.183 108.292 272.111 108.313 272.028C108.333 271.946 108.405 271.905 108.486 271.925C109.282 272.121 110.037 272.39 110.73 272.73C111.934 273.308 113.035 274.093 114.004 275.063C114.015 275.063 114.025 275.083 114.035 275.094C115.045 276.116 115.524 276.962 115.535 277.003C115.575 277.075 115.545 277.158 115.484 277.199C115.463 277.21 115.433 277.22 115.412 277.22V277.21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.159 349.757C110.159 349.922 110.18 350.097 110.18 350.263L110.292 350.82L110.159 349.757Z",
    fill: "#BBC0C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.302 352.224C110.231 352.224 110.17 352.172 110.159 352.089C110.159 352.017 109.527 345.298 107.12 338.92C105.09 333.553 102.887 327.412 100.561 320.672C98.3885 314.366 101 310.464 101.03 310.423C101.071 310.361 101.163 310.341 101.224 310.382C101.285 310.423 101.306 310.516 101.265 310.588C101.234 310.63 98.7149 314.407 100.837 320.569C103.162 327.308 105.365 333.439 107.395 338.816C109.823 345.236 110.445 351.997 110.455 352.069C110.455 352.151 110.404 352.224 110.323 352.224C110.323 352.224 110.323 352.224 110.312 352.224H110.302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.225 253.244L100.755 257.424V257.445V257.465C100.867 257.899 102.428 257.919 104.804 257.599C104.764 257.341 104.702 257.042 104.651 256.722C104.58 256.309 104.498 255.855 104.427 255.38C104.121 253.574 103.805 251.448 103.703 250.168C103.601 248.868 104.039 248.145 104.519 247.732L104.101 247.815C101.591 248.31 99.9084 250.684 100.225 253.244Z",
    fill: "#1E2F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.403 255.432C111.342 255.432 111.281 255.391 111.26 255.319C111.24 255.236 111.291 255.164 111.362 255.143C111.383 255.143 113.749 254.565 114.881 253.771C116.003 252.986 115.85 252.429 115.85 252.419C115.83 252.346 115.871 252.264 115.942 252.233C116.014 252.212 116.095 252.243 116.126 252.326C116.136 252.357 116.371 253.079 115.055 254.008C113.882 254.834 111.536 255.401 111.444 255.432C111.434 255.432 111.424 255.432 111.413 255.432H111.403Z",
    fill: "#1E2F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.027 268.447C105.14 268.447 104.13 266.052 104.12 266.021C104.09 265.949 104.12 265.867 104.192 265.846C104.263 265.815 104.345 265.846 104.375 265.918C104.416 266.011 105.334 268.168 108.017 268.168C108.129 268.168 108.231 268.168 108.353 268.158C108.425 268.158 108.496 268.209 108.496 268.282C108.496 268.354 108.445 268.426 108.363 268.426C108.251 268.426 108.129 268.437 108.017 268.437L108.027 268.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.03 268.447C102.03 268.447 101.999 268.447 101.989 268.447C99.9696 267.746 99.9492 265.496 99.9492 265.475C99.9492 265.403 100.01 265.341 100.082 265.341C100.153 265.341 100.214 265.403 100.214 265.475C100.214 265.558 100.235 267.56 102.071 268.189C102.142 268.21 102.183 268.293 102.152 268.365C102.132 268.427 102.081 268.458 102.02 268.458L102.03 268.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.328 304.829C148.328 304.829 148.236 304.809 148.205 304.757C148.165 304.685 148.185 304.602 148.256 304.561C148.879 304.169 149.205 304.014 149.307 303.993C149.378 303.973 149.46 304.035 149.47 304.107C149.48 304.179 149.44 304.262 149.358 304.272C149.338 304.272 149.144 304.334 148.399 304.798C148.379 304.809 148.348 304.819 148.328 304.819V304.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.206 304.561C147.155 304.561 147.104 304.53 147.084 304.478C147.043 304.406 147.084 304.323 147.145 304.282L147.828 303.921C147.9 303.88 147.981 303.921 148.022 303.983C148.063 304.055 148.022 304.138 147.961 304.179L147.278 304.54C147.278 304.54 147.237 304.561 147.216 304.561H147.206Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.431 304.457C146.38 304.457 146.329 304.426 146.308 304.375C146.268 304.302 146.308 304.22 146.37 304.179L146.757 303.972C146.829 303.941 146.91 303.972 146.951 304.034C146.992 304.106 146.951 304.189 146.89 304.23L146.502 304.437C146.502 304.437 146.461 304.457 146.441 304.457H146.431Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.844 308.194C134.558 308.658 135.772 309.278 136.425 309.598C136.71 309.732 137.016 309.825 137.332 309.845C138.036 309.897 139.301 310 139.26 309.99C139.852 310.103 139.75 309.422 139.209 309.164L138.985 309.051L137.761 308.452C137.761 308.452 137.751 308.452 137.73 308.431C137.608 308.338 137.169 307.967 137.139 307.616C137.088 307.224 137.465 307.079 137.485 307.059L136.741 306.677L135.884 307.183C135.252 306.605 134.517 305.913 133.773 306.697C133.395 307.131 133.426 307.802 133.854 308.184L133.844 308.194Z",
    fill: "#EDB691"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M163.686 387.731C163.686 393.875 168.672 398.856 174.821 398.856C180.971 398.856 185.957 393.875 185.957 387.731C185.957 381.587 180.971 376.605 174.821 376.605C168.672 376.605 163.686 381.587 163.686 387.731Z",
    fill: "#1E2F3F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M169.64 387.731C169.64 390.589 171.959 392.907 174.821 392.907C177.683 392.907 180.003 390.589 180.003 387.731C180.003 384.872 177.683 382.554 174.821 382.554C171.959 382.554 169.64 384.872 169.64 387.731Z",
    fill: "#B3CFC4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M163.686 387.731C163.686 393.875 168.672 398.856 174.821 398.856C180.971 398.856 185.957 393.875 185.957 387.731C185.957 381.587 180.971 376.605 174.821 376.605C168.672 376.605 163.686 381.587 163.686 387.731Z",
    fill: "#1E2F3F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M169.64 387.731C169.64 390.589 171.959 392.907 174.821 392.907C177.683 392.907 180.003 390.589 180.003 387.731C180.003 384.872 177.683 382.554 174.821 382.554C171.959 382.554 169.64 384.872 169.64 387.731Z",
    fill: "#B3CFC4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M516.563 223.837C516.294 222.721 514.706 222.721 514.437 223.837L514.088 225.282C513.992 225.681 513.681 225.992 513.282 226.088L511.837 226.437C510.721 226.706 510.721 228.294 511.837 228.563L513.282 228.912C513.681 229.008 513.992 229.319 514.088 229.718L514.437 231.163C514.706 232.279 516.294 232.279 516.563 231.163L516.912 229.718C517.008 229.319 517.319 229.008 517.718 228.912L519.163 228.563C520.279 228.294 520.279 226.706 519.163 226.437L517.718 226.088C517.319 225.992 517.008 225.681 516.912 225.282L516.563 223.837Z",
    fill: "#07EA97"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M485.762 261.877H513.01C523.958 261.877 532.848 270.255 532.848 280.572V309.79H485.762V261.877Z",
    fill: "#1D7051"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M481.052 376.632H553.967L554.999 324.356C555.017 323.45 554.872 322.546 554.568 321.685L539.522 279.007C538.355 275.697 535.043 273.459 531.307 273.459H481.052V376.632Z",
    fill: "#81AF9E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M538.863 321.834H500.884C498.529 321.834 496.619 319.926 496.619 317.575V285.905C496.619 283.289 497.533 282.118 500.884 282.118H529.287C531.976 282.118 532.412 283.289 533.284 285.469L542.941 316.325C543.782 319.064 541.73 321.832 538.863 321.832V321.834Z",
    fill: "#E5EFEB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M331.62 396.21C342.805 396.21 351.873 386.898 351.873 375.411C351.873 363.924 342.805 354.611 331.62 354.611C320.435 354.611 311.368 363.924 311.368 375.411C311.368 386.898 320.435 396.21 331.62 396.21Z",
    fill: "#1E2F3F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M272.96 348.25C272.68 348.25 267.768 348.25 267.768 343.143V222.258C267.768 215.712 269.066 213.094 276.422 213.094H382.868V348.25H272.96Z",
    fill: "#354453"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M477.478 213.094H382.868V348.25H479.934C483.153 348.25 481.658 348.25 485.761 348.25V220.941C485.761 217.018 484.889 213.094 478.35 213.094H477.478Z",
    fill: "#B3CFC4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M327.934 296.724H283.463V342.023H327.934V296.724Z",
    fill: "#B3CFC4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M377.636 279.302H320.958V342.024H377.636V279.302Z",
    fill: "#4F9078"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M287.823 348.252H480.404C483.361 348.252 481.828 348.252 485.762 348.252V377.025C481.406 377.025 483.361 377.025 480.404 377.025H287.823V348.25V348.252Z",
    fill: "#B3CFC4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 412.951,
    cy: 378.329,
    r: 21.3634,
    fill: "#1E2F3F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.388,
    cy: 377.893,
    r: 10.4637,
    fill: "#B3CFC4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.948,
    cy: 378.329,
    r: 21.3634,
    fill: "#1E2F3F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 522.384,
    cy: 377.893,
    r: 10.4637,
    fill: "#B3CFC4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5618_121606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.6393 148H12.8076C9.60016 148 7 149.803 7 152.027V174.458C7 176.682 9.60016 178.485 12.8076 178.485H81.6393C84.8467 178.485 87.4469 176.682 87.4469 174.458V152.027C87.4469 149.803 84.8467 148 81.6393 148Z",
    fill: "white"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2789 170.864C23.2542 170.864 26.4768 167.641 26.4768 163.666C26.4768 159.69 23.2542 156.468 19.2789 156.468C15.3037 156.468 12.0811 159.69 12.0811 163.666C12.0811 167.641 15.3037 170.864 19.2789 170.864Z",
    fill: "#BBC0C5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7109,
    y: 155.621,
    width: 49.9617,
    height: 5.92766,
    rx: 2.96383,
    fill: "#BBC0C5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7109,
    y: 164.936,
    width: 35.566,
    height: 5.92766,
    rx: 2.96383,
    fill: "#BBC0C5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M288 348H383V371C383 374.314 380.314 377 377 377H294C290.686 377 288 374.314 288 371V348Z",
    fill: "#81AF9E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 171,
    width: 34,
    height: 3,
    fill: "#81AF9E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 178,
    width: 34,
    height: 3,
    fill: "#81AF9E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 185,
    width: 34,
    height: 3,
    fill: "#81AF9E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 363,
    y: 171,
    width: 34,
    height: 3,
    fill: "#81AF9E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 363,
    y: 178,
    width: 34,
    height: 3,
    fill: "#81AF9E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 363,
    y: 185,
    width: 34,
    height: 3,
    fill: "#81AF9E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5618_121606",
    x: 368.561,
    y: 104.48,
    width: 105.115,
    height: 105.115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5618_121606"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.139757 0 0 0 0 0.252894 0 0 0 0 0.479167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5618_121606"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5618_121606",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5618_121606",
    x: 117.67,
    y: 51.3652,
    width: 106.809,
    height: 106.809,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5618_121606"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.139757 0 0 0 0 0.252894 0 0 0 0 0.479167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5618_121606"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5618_121606",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5618_121606",
    x: 0,
    y: 139,
    width: 106.447,
    height: 56.4854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5618_121606"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5618_121606",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5618_121606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 153,
    fill: "white",
    transform: "translate(73 247)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLayout);
export default __webpack_public_path__ + "static/media/auth_layout.aa67b8e8bde08ffafcd1c348683ae9a9.svg";
export { ForwardRef as ReactComponent };